import {Button, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";

// the openings a shared-elevation identity edit would change. Mirrors drw.SharedIdentityConflict.
export type ElevationSharedIdentityConflict = {openings: string[]};

// prompts when an identity edit (e.g. frame profile) targets an elevation shared by more
// than one opening. "Update all" fans the change out to every linked opening; "Detach"
// copies the elevation for this opening only, leaving the others untouched. See wip.md
// decision 1/2.
export function SharedElevationDialog(props: {
    conflict: ElevationSharedIdentityConflict;
    onCancel(): void;
    onResolve(resolution: "update-all" | "detach"): void;
}) {
    const openings = props.conflict.openings;

    return (
        <Dialog2 open onClose={props.onCancel}>
            <DialogTitle>Shared elevation</DialogTitle>
            <DialogContent>
                <DialogContentText style={{minWidth: 380}}>
                    This elevation is shared by {openings.length} openings
                    {openings.length > 0 && <> ({openings.join(", ")})</>}. Applying your change
                    updates all of them. Detach a private copy to change only this opening.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button onClick={() => props.onResolve("detach")}>Detach a copy</Button>
                <Button variant="contained" onClick={() => props.onResolve("update-all")}>
                    Update all {openings.length}
                </Button>
            </DialogActions>
        </Dialog2>
    );
}
